<div class="position-relative d-flex align-items-center upload-progress-container">
    <div
        data-uit="show-hide-upload-details"
        class="d-flex h-100 justify-content-between align-items-center ps-2 upload-progress"
        [class.cursor-pointer]="(uploader?.queue.length || 0) > 0"
        (click)="areUploadDetailsVisible = !areUploadDetailsVisible"
    >
        <div class="d-flex align-items-center h-100">
            <ca-icon
                *ngIf="(uploader?.queue.length || 0) > 0 || numberOfCziFilesBeingConverted > 0 || numberOfFilesBeingValidated > 0"
                name="loading"
                size="s"
                class="me-2"
            ></ca-icon>
            <!-- Uploading - "Uploading 1 file (100%)" or "Uploading 1/10 files (10%)" -->
            <ng-container *ngIf="(uploader?.queue.length || 0) > 0"
                >{{
                    uploader?.queue.length === 1 && initialValueOfFilesToBeUploaded === 1
                        ? ('MY_WORKSPACE.MY_FILES.UPLOADING_FILE' | translate)
                        : ('MY_WORKSPACE.MY_FILES.UPLOADING_FILES'
                          | translate: { count: initialValueOfFilesToBeUploaded - (uploader?.queue.length || 0), total: initialValueOfFilesToBeUploaded })
                }}
                ({{ getOverallUploadProgress() }})</ng-container
            >
            <!-- Converting - "Uploading 6/10 files (60%), converting 1 file" or "Uploading 8/10 files (80%), converting 2 files" -->
            <ng-container *ngIf="(uploader?.queue.length || 0) > 0 && numberOfCziFilesBeingConverted > 0"
                >,
                {{
                    numberOfCziFilesBeingConverted === 1
                        ? ('CZI_CONVERSION.CONVERTING_FILE' | translate | lowercase)
                        : ('CZI_CONVERSION.CONVERTING_FILES' | translate: { count: numberOfCziFilesBeingConverted } | lowercase)
                }}
            </ng-container>
            <!-- Converting - "Converting 1 file" or "Converting 2 files" -->
            <span
                *ngIf="(!uploader?.queue.length || uploader?.queue.length === 0) && numberOfCziFilesBeingConverted > 0"
                data-uit="upload-progress-container-conversion-status"
            >
                {{
                    numberOfCziFilesBeingConverted === 1
                        ? ('CZI_CONVERSION.CONVERTING_FILE' | translate)
                        : ('CZI_CONVERSION.CONVERTING_FILES' | translate: { count: numberOfCziFilesBeingConverted })
                }}
            </span>
            <!-- Validation Files -->
            <span
                *ngIf="(!uploader?.queue.length || uploader?.queue.length === 0) && numberOfCziFilesBeingConverted === 0 && numberOfFilesBeingValidated > 0"
                data-uit="upload-progress-container-validation-status"
            >
                {{ 'FILE_VALIDATION.VALIDATING' | translate }}
            </span>
        </div>
        <div *ngIf="(uploader?.queue.length || 0) > 0" class="d-flex me-1 h-100 align-items-center">
            <button
                data-uit="cancel-all-uploads"
                type="button"
                class="btn cancel-all-btn"
                (click)="cancelAllFileUploads.emit()"
                [ngbTooltip]="'GENERAL.CANCEL_ALL' | translate"
                placement="auto"
            >
                {{ 'GENERAL.CANCEL_UPLOAD' | translate }}
            </button>
            <button type="button" class="btn-expand mb-1">
                <ca-icon *ngIf="areUploadDetailsVisible" name="arrow-up" size="s"></ca-icon>
                <ca-icon *ngIf="!areUploadDetailsVisible" name="arrow-down" size="s"></ca-icon>
            </button>
        </div>
    </div>
    <div *ngIf="uploader?.queue?.length > 0 && areUploadDetailsVisible" class="position-absolute upload-details-container">
        <ca-files-upload-progress
            [uploader]="uploader"
            [dynamicClasses]="false"
            (cancelFileUpload)="cancelFileUpload.emit($event)"
            (progressChanged)="onProgressChanged()"
        ></ca-files-upload-progress>
    </div>
</div>
